module.exports = __webpack_public_path__ + "img/20180815_151538_159.0e4df749.jpg";